export default "__VITE_ASSET__Dc475HUY__"